
import { Heart, Brain, Users, Shield, Activity, Calendar } from 'lucide-react';
import type { Product } from './types';

export const mentalHealthProducts: Product[] = [
  {
    id: 'mental-health-practice-management',
    title: 'Mental Health & Therapy Practice Management',
    subtitle: 'Comprehensive mental health practice solution',
    description: 'Comprehensive mental health practice management with patient therapy tracking, secure communication, treatment planning, and wellness monitoring for optimal care outcomes in UK NHS and private healthcare settings.',
    icon: Heart,
    image: 'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    category: 'Healthcare & Medicine',
    status: 'Available',
    businessTypes: ['#healthcare', '#mental-health', '#therapy', '#wellness', '#medical-practice', '#telehealth'],
    features: [
      // Core Mental Health Management (14 features)
      'AI-Powered Mental Health Assessment & Risk Scoring with NHS Integration',
      'Personalised Treatment Planning & Evidence-Based Protocols for UK Standards',
      'Patient Therapy Tracking & Session Progress Management with CQC Compliance',
      'Secure GDPR-Compliant Communication Portal & Video Conferencing',
      'Crisis Management & Emergency Intervention Protocols (UK Emergency Services)',
      'Intelligent Session Scheduling & Appointment Optimization',
      'Clinical Notes & Documentation with Voice Recognition',
      'Prescription Management & Medication Adherence Tracking',
      'Real-Time Wellness Monitoring & Mood Tracking',
      'Group Therapy & Peer Support Coordination',
      'Outcome Measurement & Evidence-Based Analytics',
      'Provider Collaboration & Multidisciplinary Care Coordination',
      'Patient Portal & Self-Service Tools with Wellness Resources',
      'Billing & Insurance Claims Management with Mental Health Codes',

      // Advanced Therapeutic Tools & Innovation (14 features)
      'Cognitive Behavioral Therapy (CBT) Interactive Worksheets',
      'Trauma-Informed Care Protocols & EMDR Session Tracking',
      'Virtual Reality Therapy & Immersive Treatment Environments',
      'Telehealth Integration with Biometric Monitoring',
      'Family & Support Network Integration Tools',
      'Cultural Competency & Multi-Language Assessment Tools',
      'Predictive Mental Health Analytics & Relapse Prevention',
      'Mindfulness & Meditation Program Integration',
      'Behavioral Activation & Activity Scheduling Tools',
      'Substance Abuse Integration & Dual Diagnosis Support',
      'Child & Adolescent Mental Health Specialized Tools',
      'Geriatric Mental Health Assessment & Care Planning',
      'Quality Assurance & Clinical Standards Monitoring',
      'Research & Clinical Trial Management Integration',

      // Compliance & Professional Development (7 features)
      'Professional Development & Continuing Education Tracking',
      'Compliance Management & Regulatory Audit Trails',
      'Financial Reporting & Practice Analytics Dashboard',
      'Mobile App for Patients & Providers with Offline Access',
      'Electronic Health Records (EHR) Integration',
      'Peer Review & Clinical Supervision Tools',
      'Advanced Reporting & Population Health Analytics'
    ],
    pricing: { setup: 42000, monthly: 1932 },
    color: 'from-purple-500 to-pink-600'
  }
];
